// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhm_jk","CommentListPlaceholder--Legacy":"ih_b bhm_rc bhm_wq"};